import styled from "@emotion/styled"

const AuthorEmailLinkWrapper = styled.div`
  position: relative;
`

export default AuthorEmailLinkWrapper
